// images
import projectImg1 from "../images/project/memorias-cover-3.jpg";
import projectImg2 from "../images/project/memorias-cover-2.jpg";
import projectImg3 from "../images/project/memorias-cover-1.jpg";

import projectAvaterImg1 from "../images/blog/blog-avater/logopeq.png";

import projectSingleImg1 from "../images/project-single/memoria-main-img-1.jpg";
import projectSingleImg2 from "../images/project-single/memoria-main-img-2.jpg";
import projectSingleImg3 from "../images/project-single/memoria-main-img-3.jpg";
import projectSingleImg4 from "../images/project-single/memoria-main-img-4.jpg";
import projectSingleImg5 from "../images/project-single/memoria-main-img-5.jpg";
import projectSingleImg6 from "../images/project-single/memoria-main-img-6.jpg";
import projectSingleImg7 from "../images/project-single/memoria-main-img-7.jpg";
import projectSingleImg8 from "../images/project-single/memoria-main-img-8.jpg";
import projectSingleImg9 from "../images/project-single/purple-main-img-1.jpg";
import projectSingleImg10 from "../images/project-single/purple-main-img-2.jpg";
import projectSingleImg11 from "../images/project-single/purple-main-img-3.jpg";
import projectSingleImg12 from "../images/project-single/purple-main-img-4.jpg";

import mangleImg from "../images/project/mangle.png";

// audios
const audioRaizal = "https://res.cloudinary.com/dmnmgmjaz/video/upload/v1775334346/raizal_vogzwc.mp3";
const audioPalenquero = "https://res.cloudinary.com/dmnmgmjaz/video/upload/v1775334343/palenquero_e5m2lj.mp3";
const audioWayuu = "https://res.cloudinary.com/dmnmgmjaz/video/upload/v1775334344/wayuu_aiuez8.mp3";
const audioRrom = "https://res.cloudinary.com/dmnmgmjaz/video/upload/v1775334344/rrom_wqxkla.mp3";
const audioSantaLucia = "https://res.cloudinary.com/dmnmgmjaz/video/upload/v1775334344/santa-lucia_zkabqs.mp3";
const audioRepelon = "https://res.cloudinary.com/dmnmgmjaz/video/upload/v1775334343/repelon_wurbm6.mp3";
const audioManati = "https://res.cloudinary.com/dmnmgmjaz/video/upload/v1775334342/manati_mnje2r.mp3";


const proyectsSubmenu = [
  {
    id: "1",
    title: "2020 | Ilustraciones y podcast",
    mainTitle: "Memorias de la Habladorx",
    proyectLink: "/project-menu",
    pdf:"https://drive.google.com/file/d/1-ca4jZzdOBhDy-CZitHP5N7dKvPwJInX/view",
    screens: projectImg1,
    description:
      "Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle. Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle.",
    author: "DigniCO",
    bgClass: "projectImg2",
    authorTitle: "volunteer",
    authorImg: projectAvaterImg1,
    create_at: "Nov,24",
    projectSingleImg: projectSingleImg1,
    comment: "",
    blClass: "format-standard-image",
    pages: [
      {
        id: 1,
        title: "Raizal",
        audio: audioRaizal,

        mainImg: projectSingleImg4,
        texto: (
          <>
            <p>
              En las maravillosas islas de San Andrés, Providencia y Santa
              Catalina nos encontramos los Raizales; somos de origen afro,
              descendientes de la unión entre europeos, principalmente ingleses
              y algunos españoles, con esclavos africanos en su mayoría de
              Jamaica. Para mí ser raizal es vivir cada día conectándome a lo
              más profundo de la isla, y a pesar de ser criada desde nuevas
              realidades sociales en las que crecieron mis abuelos, desde
              pequeña he vivido la diversidad de mi comunidad en los bailes, en
              la música, porque nosotros los raizales en todo momento nos
              distinguimos por mantener respeto a nuestra cultura, a nuestras
              creencias y a nuestra lengua creole, un legado cultural que mezcla
              el inglés, el español, y sobre todo, el africano (García, 2003).
              <br></br>
              Mi familia es bautista, religión que predomina en la isla. Desde
              pequeña mi abuela me enseñó el respeto por nuestras creencias
              religiosas. Los domingos son un día muy especial para nosotros,
              por eso debemos prepararnos y vestirnos de manera elegante para
              honrar a Dios. Yo participé en el coro y en los grupos de la
              iglesia, en donde mi papá era pianista. Crecimos con esta
              influencia musical tan marcada, que mi hermana decidió estudiar
              Música. Dentro de las ceremonias que realizamos están nuestros
              cánticos, la lectura e interpretación de los pasajes bíblicos y
              testimonios con la participación de los fieles, la interacción
              entre pastores y feligreses (Saavedra, 2005).<br></br>
              Tras la noticia del fallecimiento de alguien cercano se acostumbra
              a visitar la casa del difunto, no sólo para manifestar nuestra
              condolencia, sino, sobre todo, para apoyar a la familia en la
              preparación y quehaceres de su casa, donde realizamos el velorio.
              Las nine nights (velorio) son este acontecimiento en donde vienen
              muchas personas de la comunidad y traen abundante comida para
              compartir entre todos, como una forma de acompañar a los
              familiares del difunto. Arreglamos la casa de blanco y negro en
              señal de luto y cubrimos todos los espejos con sábanas blancas
              para que así el espíritu no quede atrapado en ellos. También nos
              acostumbramos a dar mensajes bíblicos para la despedida de su
              espíritu, y se dan algunos testimonios de amigos cercanos contando
              su labor en su paso por la tierra (Saavedra, 2005).<br></br>
            </p>
            <blockquote>
              En nuestra música tenemos sonidos melancólicos y nostálgicos,
              cánticos asociados a la lejana tierra africana; espontáneos
              calipsos que narran episodios cotidianos o de inconformismo;
              reggae jamaiquino; alabanzas interpretadas en las iglesias;
              Country del sur de los Estados Unidos; hasta las piezas de polka y
              pasillo. Nuestros bailes típicos son el Schottiste, Quadrille, la
              Mazurca, el jumping polka, el Vals, el minuet, el foxtrot, el
              mento antillano y el calipso de influencia afrocaribe (Saavedra,
              2005). Los trajes típicos de algunos de estos bailes son formales,
              incluso con manga larga y algunos con sombrilla. El calipso sí me
              parecía un poco más descomplicado; recuerdo que desde pequeña
              usaba faldas, camisas cortas y mis trenzas con las que bailaba
              siempre descalza.
            </blockquote>
            <p>
              La gastronomía ocupa un lugar privilegiado en nuestra cultura
              Raizal, en todo evento siempre predomina la comida, especialmente
              la típica de la isla como son los frutos del mar (pescado,
              caracoles y cangrejo). Nuestro plato típico es el rundown, que
              combina el pescado y el caracol, con una deliciosa salsa de coco
              (Saavedra, 2005). Nos gusta realizar este plato en familia, en
              donde cada miembro tiene responsabilidades con los ingredientes.
              Hacer rundown es un delicioso plan en el que compartimos al
              cocinarlo y comerlo.<br></br>
              La tradición oral cobra mucha importancia para mi pueblo, al
              permitirnos transmitir prácticas culturales y mensajes que pasan
              de generación en generación a través de las historias. Por
              ejemplo, las historias de “Brother Anansi”, personaje tradicional
              de nuestros cuentos y fábulas infantiles, que se convierte en un
              héroe al evocar a nuestros ancestros africanos y el espíritu de la
              libertad que jamás pudo ser dominada a pesar de la esclavización
              física. Anansi es una araña que se caracteriza por su astucia e
              inteligencia sobre la fuerza de los animales más grandes como el
              león y el tigre para transmitir las moralejas y los mensajes
              respecto a la conducta que debemos o no seguir (Saavedra, 2005).
              Anancy, “violador de tabús” que constantemente transgrede normas
              sociales:<br></br>
              <br></br>
              Hace parte del legado cultural africano a la población Raizal por
              parte de los Fanti-Ashanti, que es la región de donde es
              originario este personaje. Cada cuento es una enseñanza de vida,
              que permite fomentar valores como la humildad, la honestidad y la
              amistad, los cuales han sido cultivados en el seno de la familia y
              transmitidos de generación en generación entre la población Raizal
              (Banco de la República, s.f).
            </p>
          </>
        ),
      },
      {
        id: 2,
        title: "Palenquero",
        audio: audioPalenquero,
        mainImg: projectSingleImg5,
        texto: (
          <>
            <p>
              Un día en mi tierra San Basilio de Palenque es conectarme con mis
              raíces Afro, con aquel territorio de la Costa Norte de Colombia
              que desde el Siglo XV se encontró poblado por cimarrones, por
              nuestros ancestros que fueron esclavos pero que lucharon por su
              libertad. Estar en Palenque es pensar en la resistencia de mi
              raza, es contagiarme de la alegría de mi pueblo, es vivir en
              nuestra danza, es sentirnos libres. Como mujer joven me
              caracterizo por reflejar nuevas expresiones de ser afro, pero es
              ese concebir y sentirme parte de mi comunidad Palenquera lo que me
              permite transmitir mi cultura y tradiciones en cada uno de mis
              días.<br></br>
              Mis abuelos me contaron que sus abuelos le contaron, que a pesar
              de no ser el único Palenque que existía, sí es el único que ha
              sobrevivido hasta hoy, convirtiéndose mi San Basilio en una
              riqueza cultural africana en el territorio del Caribe Colombiano.
              La lucha por mantener nuestro legado lo encontramos en nuestras
              historias, leyendas y cuentos, siendo la oralidad una herramienta
              de resistencia y de afirmación de nuestra identidad cultural. Por
              medio de la tradición oral mantenemos nuestra filosofía de vida
              africana. Nuestra lengua es la única criolla de las Américas que
              mantiene viva una combinación léxica española con características
              de lenguas autóctonas del continente africano, las lenguas bantúes
              (MinCultura, 2002).<br></br>
              En Palenque nuestros ancianos son los encargados de transmitir
              toda su sabiduría al resto de nuestra comunidad, cobrando su
              palabra gran valor para el mantenimiento de nuestra identidad
              musical, gastronómica, tradiciones relacionadas con la muerte, la
              medicina tradicional, la salud y las enfermedades; las fiestas;
              entre otras costumbres palenqueras.<br></br>
              Desde pequeña me contaron acerca de “las horas malas”, las doce
              del mediodía y las seis de la tarde. Durante estas se dice que se
              acercan las malas animas, los duendes y las brujas, y se cuenta
              que se llevan a los nonatos que se encuentran solos en su
              habitación y a los niños que se encuentren en el arroyo
              (MinCultura, 2009). De hecho, hay una historia famosa y respetada
              en nuestro pueblo: es la historia de Catalina Luango, quien en una
              mañana soleada en San Basilio de Palenque salió a jugar con sus
              amigas como de costumbre al arroyo. Pero ese día no fue un día
              cualquiera, ni para ella ni para su familia, como tampoco para
              todo el pueblo de Palenque. Esa mañana Catalina Luango estando en
              el arroyo vio un pez dorado gigante, y al quedar encantada por su
              hermoso y danzante movimiento, fue a buscar rápidamente su canasto
              de fique para intentar atraparlo. Con aquella extraña aparición,
              sus amigas se fueron dejándola sola en el arroyo. El pez
              coqueteaba y jugaba con Catalina, pero ella no lograba capturarlo.
              Al cabo de largas horas intentando atraparlo en vano, las personas
              empezaron a preguntar por Catalina, quien se había quedado sola en
              el arroyo; un tumulto fue a buscarla por todos lados, pero luego
              de una extenuante búsqueda, nada que aparecía. Catalina había
              desaparecido, dicen, se había enamorado de ese pez dorado. Pasados
              largos años nadie volvió a saber ni a escuchar de ella, hasta que
              un día, el día de la muerte de su madre, afuera de la iglesia, se
              escuchó su llanto, su lamento y su canto. Muchos intentaron
              hablarle, pero la joven sin decir más que esa melodía huyó y
              desapareció nuevamente dentro del arroyo. Desde entonces, en San
              Basilio de Palenque, los abuelos de mis abuelos y el resto de mi
              pueblo cuentan, con acento grave y solemne, que cada vez que muere
              alguien en la puerta de la iglesia se escucha el llanto de
              Catalina Luango, quien llora a la gente que se marcha a ese otro
              mundo.<br></br>
            </p>
            <blockquote>
              En Palenque la vida y la muerte son pilares fundamentales en
              nuestras prácticas culturales, cargadas de gran valor espiritual,
              como las prácticas del velorio y el lumbalú. Maria Lucrecia es la
              representación de la muerte en nuestra tierra de Palenque, y es
              quien separa la sombra, o el ánima del cuerpo de nuestros
              difuntos, tomando cada uno, caminos distintos. La sombra se va
              para el más allá y el cuerpo para el casariambe, el cementerio.
              Dentro de nuestros rituales fúnebres más importante en Palenque se
              encuentra el Lumbalú, un momento en donde los familiares y
              allegados ayudamos al difunto hacia su trance a la muerte durante
              nueve días y nueve noches, predominando en éste cantos de
              melancolía y dolor, expresados en nuestra música, en nuestros
              tambores (MinCultura, 2009).
            </blockquote>
            <p>
              La magia que transmite la música de Palenque se encuentra presente
              en nuestro diario vivir, en los nacimientos, en los matrimonios,
              al trabajar y hasta en los velorios. Pensar en Palenque es sentir
              el bullerengue sentado, el son palenquero, es escuchar en nuestros
              oídos el son de negro, la chasulonga y bailar champeta criolla.
              Entre nuestros representantes más conocidos está el Sexteto Tabalá
              y las Alegres Ambulancias (MinCultura, 2002). <br></br>
              Para finalizar, me gustaría hablarles de nuestra bebida ñeque, un
              trago artesanal a base de panela, así como de nuestras deliciosas
              cocadas, el bollo de yuca, el de mazorca y el de angelito; en los
              caballitos, en el mongo-mongo y en nuestra alegría hecha dulce.
              Palenque es compartir estas delicias entre nuestros vecinos y
              amigos, y es cargar con orgullo en nuestra cabeza una gran
              ponchera llena de estas delicias mientras representamos nuestra
              tierra Palenquera.
            </p>
          </>
        ),
      },
      {
        id: 3,
        title: "Pueblo Wayúu",
          audio: audioWayuu,
        mainImg: projectSingleImg6,
        texto: (
          <>
            {" "}
            <p>
              Redescubriendo mis raíces indígenas, me dirijo al Caribe
              Colombiano, en lo más norte de la península de nuestro país, para
              reencontrarme a mí misma con mi comunidad y con mi tierra,
              Wotkasainru, en la alta Guajira. Como mujer wayúu llevo conmigo
              una nueva forma de vivir las tradiciones y la cultura de mi
              pueblo, llevo a cada lugar donde voy mis tradiciones indígenas y
              el legado de mis ancestros. Recuerdo que desde pequeña he
              escuchado los relatos de nuestros ancianos lo que se cuenta sobre
              Maleiwa, la figura central de nuestro universo mítico, quien nos
              fabricó como parte de la ordenación del cosmos y la creación del
              mundo (Sánchez, 2005, p.5). Los Wayúu somos la última generación
              de herederos de una continuidad de vida en la cual la naturaleza
              se entreteje como una sociedad familiar, donde los distintos
              clanes tienen un origen totémico con sus respectivos abuelos
              animales, a los que respetamos y con los cuales nos identificamos
              (Rodríguez, 2012, p.10). Los Wayúu somos hijos de la tierra,
              nuestro lugar sagrado en que nacemos y morimos, lleno de muchas
              riquezas y de secretos mágicos aún por develar.<br></br>
              Maleiwa, al momento de crearnos, nos hizo seres conscientes, con
              el don de la palabra, dándonos leyes para regirnos: asignó cada
              animal a una familia o clan —tótem—, forjando los hierros para
              marcar cada clan y distinguirlos, uno para los Wasashi, otro para
              los Waluuseshi, los Ko’hoi, los Kasiwanot, los Apüche, los Piichi,
              entre otros. Maleiwa como el julaulashi (jefe o autoridad
              superior), nos ordenó a los Wayúu que no podíamos pelearnos y que
              teníamos que vivir en paz y respetarnos (Ministerio del Interior,
              s.f., p. 4). Nuestra organización social Wayúu está conformada por
              clanes matrilineales, teniendo cada clan un territorio propio.
              Este mandato está claramente explicitado en nuestros mitos, lo
              cual es una muestra de la designación de nuestro dios Maleiwa
              (Sanchez, 2005, p.5).<br></br>
              Para nosotros, el tío materno es la autoridad máxima quien
              interviene en problemas familiares y domésticos. Dentro de nuestra
              familia nuclear, los hijos son dirigidos prácticamente por el
              hermano de la madre y no por el propio padre biológico. Dos
              momentos centrales en nuestra vida como Wayúu son el matrimonio y
              el entierro: El primero es de crucial importancia por el prestigio
              que conlleva realizar una alianza familiar, que supone tener
              disponibilidad de recursos para ofrendar una dote a los padres de
              la mujer de otro clan y el apoyo de los suyos. Normalmente esta
              dote se representa en animales, joyas, hamacas y vasijas. Por su
              parte, respecto al entierro, nuestras mujeres son las encargadas
              de preparar al muerto, de bañarlo, colocarlo en el ataúd para
              luego ser exhumado dos años después para incineración. Para
              nosotros Wanülü representa el mal de la enfermedad o la muerte
              (Ministerio de Cultura, 2010, p.7).<br></br>
              Nuestro idioma autóctono se conoce como wayuunaiki, sin embargo,
              la mayoría de nosotros también hablamos español. La oralidad y la
              convivencia son pilares fundamentales para la transmisión de
              nuestros conocimientos y enseñanzas de los saberes Wayúu. A partir
              de la palabra, nuestros ancianos testimonian y guardan el
              patrimonio cultural y literario de nuestro pueblo, organizando un
              conjunto de relatos sagrados, convirtiéndose en las referencias
              bibliográficas del mito, el cuento y la leyenda que, además, son
              escuchados con gran solemnidad por el resto de la comunidad. Sin
              embargo, somos las mujeres Wayúu quienes debemos garantizar el
              crecimiento y continuidad de nuestros clanes, transmitiendo
              conocimientos, actitudes y conductas (Fajardo, 2006, p.6). Las
              mujeres Wayúu somos políticamente activas en nuestra sociedad, por
              lo que las autoridades femeninas son las que nos representan como
              pueblo en los espacios públicos (Ministerio de Cultura, 2010,
              p.7).<br></br>
              Los Wayúu somos reconocidos por nuestras artes ancestrales,
              especialmente por nuestro trabajo textil. Esta rica herencia
              cultural, compartida en el seno de nuestras familias, debe
              entenderse como una forma de pensar, interpretar y, al mismo
              tiempo, expresar nuestra propia vida. Me ha parecido interesante
              encontrar cómo los arijuna (quienes no son Wayúu), han empezado a
              entender que nuestra cultura es importante para la conformación de
              una Colombia unida en la multiculturalidad. Les dejo una idea
              interesante sobre nuestro universo Wayúu y la relación con los
              objetos e ideas presentes en nuestra vida diaria:
            </p>
            <blockquote>
              En las aulas hay que revalorar los procesos de pensamiento wayúu,
              pensado desde las generaciones. Gabriel Iguarán, del clan Uliana,
              nos dice que los objetos, además de ser utilitarios en la vida
              cotidiana, se convierten en maneras de concretar los procesos de
              pensamiento. Él denomina este proceso como cosas-concepto. Por
              ejemplo, en el chinchorro existe una identidad entre
              placenta-matriz de la mujer chinchorro, que se expresa en la forma
              de nombrarlos. La palabra wayuunaiki, que denomina la matriz y la
              placenta, es acho’unlaa ‘el chinchorro del niño’ y o’ulaa
              ‘chinchorro’, cuando denota acción y uso, mientras que si se habla
              de este como objeto pasivo, sin uso, se utiliza la denominación
              süi (Montiel, 2010, p. 35). 
            </blockquote>
            <p>
              Para finalizar, es importante resaltar que en nuestra cultura
              Wayúu cada uno de nuestros miembros participa y transmite a otros
              las prácticas necesarias para el mantenimiento de nuestra cultura,
              desde diferentes niveles de transmisión: El padre le enseña a su
              hijo, si es pesquero o pastor, a serlo; la madre enseña el
              quehacer del hogar, las técnicas del tejido y los principios
              morales. Desde la familia extendida se vela por la transmisión de
              historias y cuentos a través de la oralidad; y, como comunidad
              participamos en actividades y ceremonias conjuntas de nuestra
              cultura (Fajardo, 2006).
            </p>
          </>
        ),
      },
      {
        id: 4,
        title: "Rrom",
        audio: audioRrom,
        mainImg: projectSingleImg7,
        texto: (
          <>
            {" "}
            <p>
              Nómadas de la vida, hijos de la naturaleza, pertenecientes a una
              etnia sin fronteras. Para nosotros los Rrom, comúnmente conocidos
              como gitanos, el territorio es móvil, es un constante fluir, es
              vivir sin límites y ataduras geográficas, lo que nos hace
              identificarnos como ciudadanos y ciudadanas del mundo, porque para
              nosotros el territorio no se refiere a un espacio geográfico, sino
              que es algo que llevamos, es nuestra lengua, nuestras costumbres,
              es sentirnos nosotros mismos.<br></br>
              Al ser joven he moldeado partes de mis costumbres a las de los
              lugares en donde he vivido, y manifiesto día a día nuevas
              representaciones de lo que es ser gitana,  pero son esas
              tradiciones que desde pequeña me han transmitido mis abuelos las
              que me caracterizan a donde voy, porque ser gitana es llevar a mi
              familia en cada momento de mi vida representada en un amuleto o en
              una piedra, es vivir bajo el amor y respeto a la naturaleza, es
              mantener la solidaridad de nuestro pueblo.<br></br>
              Somos hijos de nuestro padre, el cielo, pero también de nuestra
              madre, la tierra, somos hijos de la naturaleza (Departamento
              Nacional de planeación, 2010). El constante fluir de ser gitanos
              en el mundo es el que nos permite ser parte integral y ocupar un
              lugar en el mundo, es para nosotros establecer relaciones con el
              universo y con los animales. Ser gitanos es mantener un balance
              con los elementos: el agua, el fuego, la tierra, el aire, a los
              que conocemos como espíritus natura (Departamento Nacional de
              planeación, 2010). Nuestra lengua ancestral a nivel mundial es el
              Romaní, la cual representa ese puente de unión de los gitanos de
              todas partes. El Romaní posee palabras de origen armenio, persa,
              árabe, castellano y de otros idiomas, recolectando todas aquellas
              trayectorias de nomadismo de nuestra comunidad gitana.<br></br>
            </p>
            <blockquote>
              Se es gitano por herencia de nuestro padre, al mantener una
              sociedad patrilineal con una línea divisoria entre el mundo de los
              hombres y el de las mujeres, siendo los hombres figuras públicas,
              encargadas de velar por el honor de la familia y representarnos en
              sociedad; mientras que nosotras las mujeres nos dedicamos a las
              labores y relaciones en el interior de nuestra familia
              (MinCultura, 2010, p.7). El matrimonio se consolida desde un
              arreglo entre familias, y se hace un intercambio o dote, el que se
              le entrega al padre de la novia como ofrenda dependiendo de
              factores como la belleza, la juventud, la “pureza de sangre” y la
              virginidad (DNP, 2010).
            </blockquote>
            <p>
              Para nosotros es muy importante ese viaje divino a la otra vida,
              es por eso que realizamos preparativos para los difuntos a los que
              se les debe poner su mejor prenda y se guarda con él sus
              posesiones más valiosas. Entre las familias nos reunimos cuando la
              persona se encuentra moribunda, cenamos y bebemos hasta su muerte:
              a pesar de las grandes muestras de dolor también se producen
              cantos y se evocan otros sentimientos. Para nosotros desde el
              momento en que se muere, se entra a un mundo trascendente, desde
              donde es posible influir sobre los familiares que permanecen en la
              tierra, siendo su protector o arrastrándoles enfermedades o
              posesiones (DNP, 2010).<br></br>
              Nuestras abuelas y otras personas de gran trascendencia son las
              que pueden practicar las artes adivinatorias, la lectura de cartas
              y de la mano, la cartomancia y la quiromancia. Dentro de estas
              poseemos símbolos de sacralidad ligados a la forma y lo que nos
              representa, como las piedras, la rueda o chakra, haciendo alusión
              a las estaciones de la vida (DNP, 2010). Desde pequeñas nuestras
              abuelas siempre nos enseñan el poder de las piedras. Yo tengo
              jades, ojo de tigre, lluvia de plata para la riqueza, perlas,
              pulseras para el mal de ojo. Una vez, en un viaje que hice a
              Argentina, mi abuela me pidió que le buscase una piedra llamada
              black star, y, por supuesto, se la traje. En esta piedra me guardó
              media alma como forma de protección, así ella me puede acompañar e
              iluminar siempre. También usamos habitualmente cascabeles como
              accesorio para llamar a los ángeles. Usar anillos y todos estos
              accesorios es llevar parte de la familia, sentir que nos están
              cuidando, que están conmigo. Desde pequeña recuerdo a mi abuela
              hablarme del poder curativo de las matas, de la magia que tienen
              las hierbas para su uso medicinal, teniendo la naturaleza conexión
              con el alma y la salud.<br></br>
              Me gustaría finalizar resaltando que, ser gitano es tener un gran
              poder adaptativo, pues siendo una minoría étnica en el mundo,
              siempre hemos logrado jugar un rol importante en las sociedades a
              las que llegamos. A pesar de encontrarnos esparcidos por muchos
              lugares en el mundo, ser gitano es mantener una representación de
              una propia nación, es llevar una lengua propia, un sistema de
              creencias y costumbres que trasciende más allá de espacios
              geográficos y fronteras.
            </p>
          </>
        ),
      },
    ],
  },
  {
    id: "2",
    title: "2021 | Habladora Mokaná",
    mainTitle: "Memorias de la Habladorx",
    screens: projectImg2,
        pdf:"https://drive.google.com/file/d/1-ca4jZzdOBhDy-CZitHP5N7dKvPwJInX/view",
    description:
      "Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle. Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle.",
    author: "DigniCO",
    authorTitle: "volunteer",
    bgClass: "projectImg2",
    authorImg: projectAvaterImg1,
    create_at: "Nov,24",
    projectSingleImg: projectSingleImg2,
    comment: "",
    blClass: "format-standard-image",
    pages: [
      {
        id: 1,
        title: "Habladora Mokaná",
        mainImg: projectSingleImg8,
        texto: (
          <>
            <p>
              Hoy en día, ese legado se ha preservado en Practicas como el Son
              de Negro Congolés o simplemente Son de Negro, un espacio de
              dialogo rítmico y folclor que acoge a esta comunidad. Las mujeres
              lucen polleras estampadas o de flores, calzan sandalias campesinas
              y se adornan el cabello con cayenas. Los hombres, por su parte,
              con sombreros campesinos cubiertos de papeles multicolores y
              calzando sandalias campesinas muestran con orgullo el torso al
              descubierto, untado con una mezcla de polvo mineral y aceite, y
              adornados con collares compuestos por diferentes materiales de la
              actividad pesquera y agrícola del sector. Es un lugar de encuentro
              que reúne y festeja el pasado y el presente de la comunidad, y en
              Santa Lucía se encuentra el mayor festival de esta danza. Sus
              orígenes se enmarcan en la colonia y buscaba encarnar el arraigo
              negro con una representación de los espacios de convivencia de las
              antiguas tribus guerreras del Congo. Se divide en tres momentos,
              el primero es el preámbulo o cabildo abierto, llamada donde se
              convoca a toda la comunidad a que se haga presente y se aliste. El
              segundo es el reposo, donde ya convocada la comunidad se la agrupa
              para realizar los diferentes ritmos que conforman las variaciones
              del Son de negro. Por último, la despedida forzosa, donde realizan
              una danza final de despedida y un “hasta pronto” (Pérez, 2017).
              Encuentro de saberes y fiesta que hacen parte de la identidad de
              este municipio. Todo esto posibilitado por el río, eje vertebrador
              de un municipio que ha sabido vivir a sus orillas. Santa Lucía ha
              crecido en base a la pesca y la agricultura proveídas por el río,
              se ha posicionado a través del transporte y comercio. por medio
              del Canal del Dique que conecta a Cartagena y su histórico puerto
              con el interior del país. Durante siglos ha surtido a la zona de
              todos los elementos básicos para la vida, y por eso constituía un
              lugar de refugio para aquellos cimarrones que buscaban subsistir
              por fuera del sistema esclavista. A pesar de nunca fue un entorno
              del todo sencillo, permitió prosperar a Santa Lucía como a muchos
              otros municipios ribereños, pero esta obra de ingeniería también
              marcaría a sus habitantes con una tragedia nunca antes vista.
            </p>
            <blockquote>
              Fiestas, tradición y baile se enmarcan aquí. Santa lucía
              constituye uno de los municipios ribereños del Canal del Dique,
              una bifurcación artificial que se habilitó para proveer a
              Cartagena de las aguas del río Magdalena en tiempos de la colonia,
              y desde entonces fue lugar de acogida de múltiples Palenques, de
              cimarrones en busca de su libertad. Aunque a día de hoy, de todo
              este proceso solo se ha mantenido San Basilio de Palenque, el
              poblamiento de estas zonas ha permitido que Santa Lucía crezca
              como un espacio de sincretismos entre diversas culturas y
              tradiciones que han sabido relatar su historia.
            </blockquote>
            <p>
              El desbordamiento del Canal del Dique en 2010 provocó la
              inundación de múltiples municipios del sur del Atlántico y el
              norte de Bolívar, por causa de un desprendimiento de tierra debido
              a las fuertes lluvias que golpeaban a la región en ese momento,
              aumentando el caudal del canal. Decenas de miles de personas se
              encontraron repentinamente con el agua hasta el pecho y con sus
              pertenencias completamente sumergidas, paralizando a toda la
              comunidad. No era posible moverse por sus calles por otro medio
              que no fueran canoas o lanchas. No solo viviendas, el agua también
              había arrasado más de 32000 hectáreas de tierra fértil (Herrera,
              2020), miles de personas se vieron desplazadas de sus hogares y,
              aunque se hicieron millonarios esfuerzos por reconstruir lo
              dañado, intensificó el dolor de una población que desde años atrás
              ya sufría. Santa Lucía es reconocido como un territorio víctima de
              desplazamiento forzado durante el conflicto armado en Colombia y
              esta tragedia solo acrecentaba la problemática. No obstante, al
              igual que las aguas del río, las miles de familias desplazadas de
              sus hogares poco a poco fueron retornando. Miles de casas fueron
              reconstruidas, sus calles volvieron a ser caminadas y sus colegios
              volvieron a abrir sus puertas. Hoy en día Santa Lucía sigue
              transitando un proceso de reparación, hace parte de la Ruta de la
              memoria que se construye a lo largo de los diversos municipios del
              Canal del Dique víctimas del conflicto armado, ordenado por la
              Jurisdicción Especial para la Paz (JEP). Cada vez crece más el
              interés de la comunidad para ser partícipes de estos procesos,
              para ser partícipes de su destino. Lo han creado a partir de la
              cultura, el Festival del Son de Negro volvió a estrechar los
              vínculos de la comunidad lastimados por el desplazamiento y la
              perdida. Hoy el río los vuelve a proveer de su sustento. Los reúne
              y nos reúne para hacer memoria, de lo fueron y de lo que son, de
              sus vivencias y de lo que hace parte de ser santalucense
            </p>
          </>
        ),
      },
    ],
  },
  {
    id: "3",
    title: "2024 | Memorias del Río",
    mainTitle: "Memorias de la Habladorx",
    pdf:"https://drive.google.com/file/d/1-ca4jZzdOBhDy-CZitHP5N7dKvPwJInX/view",
    screens: projectImg3,
    description:
      "Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle. Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle.",
    author: "DigniCO",
    authorTitle: "volunteer",
    bgClass: "projectImg2",
    authorImg: projectAvaterImg1,
    create_at: "Nov,24",
    projectSingleImg: projectSingleImg3,
    comment: "",
    blClass: "format-standard-image",
    pages: [
      {
        id: 1,
        mainImg: projectSingleImg1,
        title: "Santa Lucía",
        audio: audioSantaLucia,
        texto: (
          <>
            <p>
              Hoy en día, ese legado se ha preservado en Practicas como el Son
              de Negro Congolés o simplemente Son de Negro, un espacio de
              dialogo rítmico y folclor que acoge a esta comunidad. Las mujeres
              lucen polleras estampadas o de flores, calzan sandalias campesinas
              y se adornan el cabello con cayenas. Los hombres, por su parte,
              con sombreros campesinos cubiertos de papeles multicolores y
              calzando sandalias campesinas muestran con orgullo el torso al
              descubierto, untado con una mezcla de polvo mineral y aceite, y
              adornados con collares compuestos por diferentes materiales de la
              actividad pesquera y agrícola del sector. Es un lugar de encuentro
              que reúne y festeja el pasado y el presente de la comunidad, y en
              Santa Lucía se encuentra el mayor festival de esta danza. Sus
              orígenes se enmarcan en la colonia y buscaba encarnar el arraigo
              negro con una representación de los espacios de convivencia de las
              antiguas tribus guerreras del Congo. Se divide en tres momentos,
              el primero es el preámbulo o cabildo abierto, llamada donde se
              convoca a toda la comunidad a que se haga presente y se aliste. El
              segundo es el reposo, donde ya convocada la comunidad se la agrupa
              para realizar los diferentes ritmos que conforman las variaciones
              del Son de negro. Por último, la despedida forzosa, donde realizan
              una danza final de despedida y un “hasta pronto” (Pérez, 2017).
              Encuentro de saberes y fiesta que hacen parte de la identidad de
              este municipio. Todo esto posibilitado por el río, eje vertebrador
              de un municipio que ha sabido vivir a sus orillas. Santa Lucía ha
              crecido en base a la pesca y la agricultura proveídas por el río,
              se ha posicionado a través del transporte y comercio. por medio
              del Canal del Dique que conecta a Cartagena y su histórico puerto
              con el interior del país. Durante siglos ha surtido a la zona de
              todos los elementos básicos para la vida, y por eso constituía un
              lugar de refugio para aquellos cimarrones que buscaban subsistir
              por fuera del sistema esclavista. A pesar de nunca fue un entorno
              del todo sencillo, permitió prosperar a Santa Lucía como a muchos
              otros municipios ribereños, pero esta obra de ingeniería también
              marcaría a sus habitantes con una tragedia nunca antes vista.
            </p>
            <blockquote>
              Fiestas, tradición y baile se enmarcan aquí. Santa lucía
              constituye uno de los municipios ribereños del Canal del Dique,
              una bifurcación artificial que se habilitó para proveer a
              Cartagena de las aguas del río Magdalena en tiempos de la colonia,
              y desde entonces fue lugar de acogida de múltiples Palenques, de
              cimarrones en busca de su libertad. Aunque a día de hoy, de todo
              este proceso solo se ha mantenido San Basilio de Palenque, el
              poblamiento de estas zonas ha permitido que Santa Lucía crezca
              como un espacio de sincretismos entre diversas culturas y
              tradiciones que han sabido relatar su historia.
            </blockquote>
            <p>
              El desbordamiento del Canal del Dique en 2010 provocó la
              inundación de múltiples municipios del sur del Atlántico y el
              norte de Bolívar, por causa de un desprendimiento de tierra debido
              a las fuertes lluvias que golpeaban a la región en ese momento,
              aumentando el caudal del canal. Decenas de miles de personas se
              encontraron repentinamente con el agua hasta el pecho y con sus
              pertenencias completamente sumergidas, paralizando a toda la
              comunidad. No era posible moverse por sus calles por otro medio
              que no fueran canoas o lanchas. No solo viviendas, el agua también
              había arrasado más de 32000 hectáreas de tierra fértil (Herrera,
              2020), miles de personas se vieron desplazadas de sus hogares y,
              aunque se hicieron millonarios esfuerzos por reconstruir lo
              dañado, intensificó el dolor de una población que desde años atrás
              ya sufría. Santa Lucía es reconocido como un territorio víctima de
              desplazamiento forzado durante el conflicto armado en Colombia y
              esta tragedia solo acrecentaba la problemática. No obstante, al
              igual que las aguas del río, las miles de familias desplazadas de
              sus hogares poco a poco fueron retornando. Miles de casas fueron
              reconstruidas, sus calles volvieron a ser caminadas y sus colegios
              volvieron a abrir sus puertas. Hoy en día Santa Lucía sigue
              transitando un proceso de reparación, hace parte de la Ruta de la
              memoria que se construye a lo largo de los diversos municipios del
              Canal del Dique víctimas del conflicto armado, ordenado por la
              Jurisdicción Especial para la Paz (JEP). Cada vez crece más el
              interés de la comunidad para ser partícipes de estos procesos,
              para ser partícipes de su destino. Lo han creado a partir de la
              cultura, el Festival del Son de Negro volvió a estrechar los
              vínculos de la comunidad lastimados por el desplazamiento y la
              perdida. Hoy el río los vuelve a proveer de su sustento. Los reúne
              y nos reúne para hacer memoria, de lo fueron y de lo que son, de
              sus vivencias y de lo que hace parte de ser santalucense
            </p>
          </>
        ),
        video: (
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/ZzZPAGrN6kU?si=hjcK5MMho0TJCs3i"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        ),
      },
      {
        id: 2,
        mainImg: projectSingleImg2,
        title: "Repelón",
        audio: audioRepelon,
        texto: (
          <>
            {" "}
            <p>
              En épocas de la colonia, hoy en día sumergido por el embalse, se
              encontraba el palenque San Benito de las Palomas, uno de los
              tantos palenques formados por cimarrones fugitivos para establecer
              comunidades libres y autónomas. Sin embargo, debido a problemas y
              retrasos en la construcción del Canal del Dique la depresión del
              Guájaro, donde se ubicaba el palenque, se empezó a inundar. Lo que
              obligó a sus pobladores a refugiarse en las áreas de cultivo que
              se encontraban un poco más alejadas; en sus “repelones”, como le
              llamaban (El Tiempo, 1998). Es ese el origen de los primeros
              pobladores de esta tierra, los que darían comienzo a este
              municipio, un tesoro cultural en el sur del Atlántico. El Canal
              del Dique ha sido ese lugar que ha movido la historia de Repelón.
              Desde las múltiples inundaciones que incluso lograron restablecer
              su ubicación, sumergiendo el palenque del que se origina, y
              posteriormente en 2010 volviendo a sumergir las viviendas de su
              población. Hasta ser la fuente de agua vital para sus cultivos de
              yuca, maíz, tabaco, algodón, caña de azúcar, dividivi y arroz, que
              los convirtieron durante la segunda mitad del siglo XIX y hasta
              mediados del siglo XX en la despensa agrícola del departamento. No
              solo cultivos sino también siendo un enclave pesquero que ha sido
              parte fundamental de la dieta local. El canal ha sido una zona
              clave de la historia del país y repelón ha sabido encontrarse en
              medio de este. El carácter de sus habitantes, su cultura y
              tradición son herencia del río, núcleo de este municipio. Por otro
              lado, sus fiestas patronales denotan la importancia histórica de
              la religión en el municipio, ya desde los tiempos del palenque.
              Originalmente esta fe encontró su patrono en San Benito de
              Palermo, religioso africano, hijo de esclavos, canonizado en 1807.
              Pero como lo muestra el nombramiento del palenque, reconocido
              ampliamente desde tiempos anteriores. Ya constituido Repelón, San
              Antonio de Padua se erige como el nuevo patrono de sus habitantes.
              Cada 13 de junio con procesiones y ceremonias permiten a los
              participantes expresar su devoción y mantener vivas las
              tradiciones espirituales del municipio. De la misma manera,
              durante este día tan esperado que convoca tanto a locales como
              visitantes en las calles y plazas del pueblo, también se llenan de
              vida con una variada oferta de actividades que reflejan la riqueza
              cultural y el entusiasmo de su gente.
            </p>
            <blockquote>
              Llegó a ser conocida como la despensa agrícola del Atlántico. Su
              cercanía al embalse del Guájaro le dotaba de un sistema de riego
              ideal para la agricultura, actualmente, su nombre refleja ese
              legado.
            </blockquote>
            <p>
              Las cabalgatas, por un lado, desfilan majestuosamente a través de
              las avenidas, ofreciendo un espectáculo colorido y festivo que
              celebra las tradiciones ecuestres del lugar. No menos importantes
              son los encuentros deportivos, que se convierten en una plataforma
              para la competencia sana entre los habitantes y los visitantes.
              Además de otros eventos variados, que abarcan desde danzas típicas
              hasta desafíos gastronómicos, que añaden un elemento de diversión
              y alegría al día festivo. Celebrando así el vibrante mosaico de
              talentos y tradiciones que caracterizan al municipio. En conjunto,
              estas festividades crean una experiencia inolvidable que une a la
              comunidad y resalta el carácter único del lugar. No obstante, no
              todo ha sido alegría en Repelón. Episodios de violencia dejaron
              una huella imborrable en la comunidad, con desplazamientos
              forzados, pérdidas humanas y una sensación general de inseguridad
              que afectó gravemente la vida cotidiana de sus habitantes. A día
              de hoy, todavía son recordadas las dos incursiones del Bloque
              Norte de las Autodefensas Unidas de Colombia en el corregimiento
              de Pita. A pesar de ello, el municipio ha sido testigo de un
              notable esfuerzo por parte de sus líderes comunitarios y
              autoridades locales para fomentar la reconciliación y la
              construcción de una paz duradera. Las iniciativas en Repelón se
              han centrado en la promoción del diálogo, la reparación de
              víctimas y la consolidación de la presencia del Estado para
              garantizar la seguridad y el desarrollo. Repelón hace parte de la
              Ruta de la memoria, ordenada por la Jurisdicción Especial para la
              Paz (JEP), que se construye a lo largo de los diversos municipios
              del Canal del Dique víctimas del conflicto armado. La experiencia
              de Pita y su trayectoria en el conflicto se han convertido en un
              testimonio importante de la resiliencia y la capacidad de
              recuperación de las comunidades afectadas. Actos, como la vigilia
              por la paz cada 29 de septiembre, y la presencia de entidades como
              el Instituto Colombiano de Bienestar Familiar (ICBF), espacios de
              acompañamiento psicosocial y fomento de proyectos productivos dan
              cuenta de ello (Unidad de Víctimas, 2020). Es un proceso largo el
              que ha constituido lo que hoy es Repelón. Aquí, su gente hace
              memoria de su historia y de su cultura. No como algo ya escrito,
              sino que se sigue escribiendo, o más bien narrando. Así es como su
              comunidad día a día sigue construyendo la identidad del municipio.
            </p>
          </>
        ),
        video: (
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/3zpezKRVc3Q?si=k58J4gCYnoBw9vVx"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        ),
      },
      {
        id: 3,
        mainImg: projectSingleImg3,
        title: "Manatí",
        audio: audioManati,
        texto: (
          <>
            {" "}
            <p>
              “Sí la vida nada vale / pajarito de la ma’ / ¿cuál será la
              solución? / pajarito de la ma’ / ¿para qué tanta violencia? /
              pajarito de la ma’ / con eso no se saca na’ / pajarito de la ma’”
              Se dice que originalmente estas tierras eran conocidas como
              Mahabana, en honor a un cacique indígena llamado Mahada.
              Posteriormente, durante la colonia se refunda como Villa de San
              Luis Beltrán, en honor al santo dominico que había pisado sus
              tierras durante sus misiones de evangelización. Este nombre no
              solo reflejaba el impacto religioso y cultural de la misión, sino
              que también simbolizaba el vínculo espiritual entre el santo y la
              comunidad emergente (Caballero, 2022).
            </p>
            <blockquote>
              Sin embargo, la identidad de la villa experimentó una
              transformación notable cuando un inesperado suceso cambió su
              denominación para siempre. Un día, unos pescadores locales
              encontraron un manatí en la ciénaga cercana, un hallazgo tan
              sorprendente y singular que capturó la imaginación de todos los
              habitantes.
            </blockquote>
            <p>
              Este mamífero acuático, conocido por su tamaño imponente y su
              comportamiento pacífico, se convirtió en un símbolo de asombro y
              fascinación. El descubrimiento del manatí fue tan impactante que
              los habitantes decidieron cambiar el nombre de la villa en su
              honor, marcando así un giro en la identidad del lugar. La elección
              del nombre, de inspiración tan azarosa, subraya la manera en que
              lo inesperado ha moldeado el carácter de esta comunidad. Tierra
              del Son de Pajarito, Manatí es un centro de cultura en la ribera
              del Canal del Dique. El color, las polleras, babuchas y flores en
              el cabello se destacan en las mujeres, mientras que los hombres
              lucen sombreros, pantalones negros o blancos, camisas de colores,
              y andan en abarcas o descalzos; todos elementos de su tradición y
              cotidianidad que conforman las vestimentas características de este
              baile (Pérez, 2010). En octubre, la ciudad se transforma en la
              capital del Son de Pajarito, albergando el festival más importante
              de esta danza típica. Conocido de esta forma por la manera en la
              que las mujeres mueven sus polleras durante el baile, imitando el
              vuelo de los pájaros, y evocando una imagen de libertad y vida.
              Igual de importante que el baile es la música con la que lo
              acompaña. Ahí los “instrumentos típicos como el tambor alegre,
              tambor llamador, guaches o maracas, claves o tablitas, palmas y
              voces que imponen el ritmo musical, con versos que expresan los
              sucesos de la vida cotidiana” (Romero, 2020) a través de sus
              músicos, cantaoras y cantaores. El espectáculo musical, con su
              vibrante combinación de sonidos y ritmos, inunda las calles del
              municipio con una energía contagiosa y una alegría desbordante. De
              igual manera, y a pesar del cambio de nombre, Manatí sigue
              vibrando con una rica tradición religiosa. Desde el 29 de
              noviembre, la comunidad se despierta a las 4 de la madrugada para
              acompañar a la Inmaculada Concepción, patrona del pueblo, en su
              recorrido por los barrios que la solicitan. Cada barrio se adorna
              festivamente, y la plaza principal se llena de vida y entusiasmo
              mientras los vecinos siguen a la virgen. Las celebraciones
              continúan por la noche con fandangos en la plaza, manteniendo viva
              una tradición que une y alegra a todo el pueblo. Por otra parte,
              el nombre más reciente también hace parte de la identidad cultural
              del municipio. Al igual que muchos de los municipios ribereños del
              Canal del Dique, este ha sido clave para su desarrollo. Desde
              proveer agua dulce para abastecer a sus cultivos, como fuente de
              alimentos en su tradicional práctica pesquera. Práctica que dio
              origen al nombre del municipio como se mencionaba más arriba.
              Pero, también ha sido lugar de origen de múltiples inundaciones
              del municipio cuando arrecian las temporadas invernales. Su
              historia solo se puede entender a través de las aguas del canal.
              Son estas aguas, provenientes del río magdalena las que dan la
              clave para comprender los procesos que se viven en el municipio.
              El único municipio que ha vivido una toma guerrillera en el
              departamento del Atlántico, autoría del EPL (Trejos, 2020). Pero,
              también un municipio que ha vivido un amplio proceso de
              reparación. Visto en el pago de indemnizaciones a las víctimas de
              una violencia que los ha marginado del país y los ha anulado como
              ciudadanos de una nación democrática (Unidad de Víctimas, 2018). Y
              también en el ordenamiento de la Justicia Especial para la Paz
              (JEP), de construir una Ruta de la memoria que busque continuar el
              proceso reparador para los habitantes de municipios víctimas del
              conflicto armado en el Canal del Dique. Pues la memoria se ha
              convertido en una herramienta clave de justicia, reparación,
              movilización y cambio de las comunidades. Un proceso transformador
              de realidades que hace posible el reabrir espacios de diálogo que
              conforman el sentir de una comunidad.
            </p>
          </>
        ),

        video: (
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/3zpezKRVc3Q?si=k58J4gCYnoBw9vVx"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        ),
      },
    ],
  },
  {
    id: "4",
    title: "Purple Circle",
    mainTitle: "Purple Circle",
    pdf:"https://drive.google.com/file/d/1xUv641lZyD8ZKqFKrRAthl_f2r1DqCCn/view?usp=drive_link",
    screens: projectImg3,
    description:
      "Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle. Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle.",
    author: "DigniCO",
    bgClass: "projectImg3",
    authorTitle: "volunteer",
    authorImg: projectAvaterImg1,
    create_at: "Nov,24",
    projectSingleImg: projectSingleImg3,
    comment: "",
    blClass: "format-standard-image",
    pages: [
      {
        id: 1,
        mainImg: projectSingleImg9,
        title: "Leadership",
        texto: (
          <>
            <p>
              Las comunidades se construyen desde las interacciones existentes
              entre los individuos que toman decisiones, actúan y conviven bajo
              ciertas reglas e intereses que implica un proceso participativo en
              el que los agentes comunitarios median de manera voluntaria. Es
              por esto que existe una asociación directa entre la participación
              y el liderazgo; el uno sin el otro puede dificultar el logro de
              los objetivos propuestos por las comunidades. El liderazgo desde
              una visión comunitaria es el medio por el que transitan los
              elementos necesarios para la utilización de los recursos del
              entorno y sus oportunidades de mejora. Por consiguiente, en la
              actualidad es indispensable la participación juvenil, que potencie
              el desarrollo de la sociedad por medio de nuevos canales que
              originen nuevas formas de contribución. Lo anterior desde una
              perspectiva de género que implique revisar la calidad
            </p>
          </>
        ),
      },
      {
        id: 2,
        mainImg: projectSingleImg10,
        title: "Work towards conflict",
        texto: (
          <>
            <p>
              El conflicto es un proceso social en el que de forma recíproca
              varias personas o grupos contienden, es decir, contraponen
              opiniones y/o puntos de vista como adversarios. <br></br>Aunque de
              esta negativa es posible lograr una resolución que revele
              aprendizajes entre los involucrados y origine experiencias
              positivas como alternativa a la diferencia. La negociación y la
              mediación son unas de las alternativas de resolución de
              conflictos. Primeramente, en la negociación se hace necesario una
              buena comunicación, que incluye el buen manejo de la escucha,
              sobre todo de retroalimentación, para que así las partes lleguen a
              un acuerdo. De la misma manera, la mediación visibiliza la
              comunicación en donde la persona mediadora es parte fundamental en
              el proceso. Esta orienta de forma objetiva a la resolución del
              conflicto procurando el beneficio de las partes, y busca eliminar
              o reducir la conducta conflictiva.<br></br>
              Cuando el conflicto se maneja adecuadamente puede convertirse en
              un verdadero motor de desarrollo. Los actores involucrados en un
              buen manejo del conflicto pueden presentar las siguientes
              actitudes:
            </p>
            <ul style={{ listStyleType: "disc" ,listStylePosition: "inside"}}>
              <li>
                Aceptar la condición humana y la cadena de conflictos para
                aprender a sobrellevarlos y a asumirlos como un estímulo.
              </li>
              <li>Enfrentar y manejar el conflicto en vez de evitarlo.</li>
              <li>Aceptar a los demás cuando plantean ideas diferentes.</li>
              <li>
                Aprender a dialogar sin fomentar las polémicas y el «diálogo de
                sordos».
              </li>
              <li>Entender a los actores y no asumir posiciones defensivas.</li>
              <li>Fomentar la actitud de «ganar-ganar».</li>
              <li>Evitar reprimir o explotar la agresividad</li>
            </ul>
          </>
        ),
      },
      {
        id: 3,
        mainImg: projectSingleImg11,
        title: "Works, stereotypes and identities",
        texto: (
          <>
            <p>
              El ser humano se destaca por ser capaz de reconocerse y definirse
              teniendo en cuenta los aspectos relacionados con lo físico,
              académico, profesional, familiar, socioeconómico, etnico, cultural
              y sexual. Por lo que la identidad es un constructo que compendia
              de todo lo anterior y debe ser considerado como rasgos o
              características cambiantes que son influenciadas por las
              relaciones interpersonales e intrapersonales que dan lugar en el
              contexto cultural propio Dentro de esos aspectos que integran la
              identidad se encuentra el sexo, que hace referencia a un proceso
              biológico que se relaciona a las caracteristicas fisiológicas que
              se establecen según la percepción de los genitales durante el
              embarazo o en el momento del nacimiento, en el que identifican a
              la persona como hombre o mujer. Por otro lado, es de vital
              importancia conocer el género, que a diferencia del sexo, es una
              construcción social que depende de la cultura o la época vigente.
              Este hace referencia a las normas, roles, oportunidades,
              comportamientos, cualidades, privilegios, obligaciones, atributos
              que la sociedad asigna a los hombres (masculino) y a las mujeres
              (femenino).
            </p>

            <p>
              Del rol de género, basado en las concepciones, creencias o
              convicciones de la sociedad, se originan las normas de género y
              los estereotipos. El primero apunta a cuando se establece
              socialmente el actuar de la vida de la persona, según su sexo y
              género, por ejemplo, “eres niño, no puedes jugar con muñecas” o
              “una mujer tiene que quedarse en la casa para la crianza de los
              hijos”. Por otra parte, los estereotipos son las creencias
              sociales que asignan características controvertibles por ser
              biológicamente hombre o mujer, por ejemplo, “el rosado no es para
              los hombres, es para las mujeres” o “solo las mujeres pueden
              llevar el cabello largo”. Estos estereotipos y prejuicios dentro
              de las sociedades derivan en discriminaciones hacia mujeres y
              poblaciones minoritarias en contextos laborales. Es deber del
              estado y de las instituciones garantizar políticas favorables que
              promuevan la equidad y la diversidad, y sobre todo el derecho al
              trabajo digno sin distinciones desde un enfoque interseccional.
            </p>
          </>
        ),
      },
      {
        id: 4,
        mainImg: projectSingleImg12,
        title: "Co - Construction citizenship",
        texto: (
          <>
            {" "}
            <p>
              El concepto de derechos humanos reconoce que a cada ser humano le
              corresponde disfrutar de sus derechos humanos sin distinción de
              raza, color, sexo, género, idioma, religión, opinión política o de
              otra índole, origen nacional o social, propiedad, nacimiento u
              otra condición. Toda mujer tiene derecho a una vida libre de
              violencia, en la que pueda ejercer sus derechos civiles,
              políticos, económicos, sociales y culturales contando con la
              protección de esos derechos en los instrumentos regionales e
              internacionales sobre derechos humanos.
            </p>
            <p>
              Entre los derechos humanos hacen parte los Derechos Sexuales y
              Reproductivos que le permita a las mujeres disfrutar de una vida
              digna, que le reconoce su capacidad de decidir de forma libre,
              consciente y responsable sobre su cuerpo y proyecto de vida, como
              la cantidad de hijas/os que tendrán, en qué momento y su
              espaciamiento, y de tener la información y los medios para
              hacerlo, y el derecho de lograr el nivel más alto de salud sexual
              y reproductiva10. Estos derechos son universales (todas las
              personas nacen con los mismos derechos), indivisibles (todos los
              derechos son igualmente necesarios para la vida y dignidad de una
              persona) e interdependientes (todos los derechos están
              relacionados entre sí)
            </p>
            <p>
              Para co-construir una ciudadanía con perspectiva de género implica
              que como comunidad con una realidad social se aborde teniendo en
              cuenta las desigualdades presentes entre hombres y mujeres, y las
              relaciones de género que establecen diferencias en la posición
              relativa de mujeres y hombres, a transformarlas en relaciones
              equitativas con un compromiso social que impacte positivamente.
            </p>
          </>
        ),
      },
    ],
  },
  {
    id: "5",
    title: "Mangle",
    mainTitle: "Mangle",
    screens: mangleImg,
    description:
      "Programa orientado al fortalecimiento del tejido social en relación con la naturaleza, como base para una transformación hacia una cultura de paz y una justicia ambiental en el Caribe colombiano.",
    author: "DigniCO",
    bgClass: "projectImg4",
    authorTitle: "volunteer",
    authorImg: projectAvaterImg1,
    create_at: "2025",
    projectSingleImg: mangleImg,
    comment: "",
    blClass: "format-standard-image",
    pages: [
      {
        id: 1,
        title: "Mangle",
        mainImg: mangleImg,
        texto: (
          <>
            <p>
              El programa Mangle de la Fundación DigniColombia busca fomentar
              procesos micropolíticos y pedagógicos en el Caribe colombiano,
              orientados al fortalecimiento del tejido social en relación con la
              naturaleza, como base para una transformación hacia una cultura de
              paz y una justicia ambiental. Para ello, se promueven espacios
              dialógicos y restaurativos que invitan a la reflexión colectiva y a
              la coconstrucción de escenarios sociales más pacíficos, integrando
              un enfoque ambiental a las diversas narrativas del territorio, el
              género y las culturas que lo habitan.
            </p>
            <blockquote>
              Una vida son muchas vidas entreveradas. El mangle es expresión de
              esta naturaleza que convoca a la armonía, al equilibrio, a la paz,
              a la justicia social y ambiental. El mangle inspira a pensarnos en
              esa delicada, pero profunda relación entre el ser humano y la
              naturaleza.
            </blockquote>
          </>
        ),
      },
    ],
  },
];

export default proyectsSubmenu;
